import { Component, inject } from '@angular/core';
import { BookVisitErrorModalResult } from '@app/booking-part/models/book-visit-error-modal-result.enum';
import { BookVisitStatus } from '@app/shared/enums/book-visit-status.enum';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { PasswordResetService } from '@app/shared/services/password-modification/password-reset.service';

@Component({
  selector: 'app-customer-data-error-modal',
  templateUrl: './customer-data-error-modal.component.html',
  styleUrls: ['./customer-data-error-modal.component.scss']
})
export class CustomerDataErrorModalComponent {
  public status: BookVisitStatus;
  public subject: Subject<BookVisitErrorModalResult>;
  public BookVisitStatus = BookVisitStatus;
  public activeModal = inject(NgbActiveModal);
  public authService = inject(AuthService);
  public passwordResetService = inject(PasswordResetService);

  tryAgain(): void {
    this.subject.next(BookVisitErrorModalResult.TryAgain);
    this.activeModal.close();
  }

  changeVisitSlot(): void {
    this.subject.next(BookVisitErrorModalResult.ChangeVisitSlot);
    this.activeModal.close();
  }

  onCloseClicked(): void {
    this.activeModal.close();
  }

  onResetPassword(): void {
    this.passwordResetService.resetPassword(true);
  }

  openSignInPopup(): void {
    this.authService.signIn$()
      .subscribe();
    this.activeModal.close();
  }
}
